import axios from 'axios';
import { IChannelCategoryRepository } from '../../application/ports/IChannelCategoryRepository';
import { ChannelCategoryEntity } from '../../domain/entities/ChannelCategory';
import { advertizerApiHost } from '../../constants/envs';
import { AuthTokenProvider } from '../auth/AuthTokenProvider';
import { mapApiToEntity } from '../mappers/channelCategories.mapper';

export class ChannelCategoriesAxiosRepository implements IChannelCategoryRepository {
  constructor(private auth: AuthTokenProvider) {}

  private async authHeaders() {
    const token = await this.auth.getToken();
    if (!token) throw new Error('Unauthenticated');
    return { Authorization: `Bearer ${token}` };
  }

  async list(): Promise<ChannelCategoryEntity[]> {
    const headers = await this.authHeaders();
    const res = await axios.get(advertizerApiHost + '/api/channel_categories', { headers });
    return (res.data.categories ?? []).map((c: any) => mapApiToEntity(c));
  }
}
